import React from "react";
import {Input} from 'reactstrap'

// list box component for selecting country from rs

const SelectCountry = (props) => {
  const { options,tab, name, onChange, value, onKeyPress,widthValue } = props;
  console.log(options)
  
  return (
    <div>
      <Input
        tabIndex={tab}
       type="select"
        onChange={onChange}
        style={{ height: "40px", marginTop: "2px", width: `${widthValue}` }}
        onKeyPress={onKeyPress}
        name={name}
        id={name}
        value={value}
      >
           <option hidden value = "">Select a  Value</option>
        { options.length > 0 && options.map((option) => {
          return (
         
            <option key={option.countryName} value={option.countryName}>
              {option.countryName}
            </option>
          );
        })}
      </Input>
    </div>
  );
};

export default SelectCountry;
